import { ref, watch, computed } from "vue-demi";

// Pinia
import { defineStore } from "pinia";
import { usePageStore } from "@/stores/pageHeader";
import { useAppStore } from "@/stores/app";

// Utils
import { postData } from "@utils";
import { useRouter } from "@core/utils";

// Plugin
import { useToast } from "vue-toastification/composition";
import moment from "moment";

export const useDocumentStore = defineStore("document", () => {
  // Initial
  const appStore = useAppStore();
  const pageStore = usePageStore();
  const { route } = useRouter();
  const toast = useToast();
  const cardDisabled = ref(true);
  const isError = ref(false);

  // Document

  const documentType = ref({
    title: "",
    slug: "",
    docType: "",
    orderType: "",
  });

  const documentTypes = ref([
    {
      slug: "order",
      title: "Siparişler",
      head: "Sipariş No",
      docType: "",
      orderType: 1,
      statu: false,
      actions: false,
    },
    {
      slug: "waybill",
      title: "İrsaliyeler",
      head: "İrsaliye No",
      docType: "",
      orderType: 3,
      statu: true,
      actions: true,
    },
    {
      slug: "bill",
      title: "Faturalar",
      head: "Fatura No",
      docType: "",
      orderType: 4,
      statu: true,
      actions: true,
    },
    {
      slug: "HF",
      title: "Hizmet Faturaları",
      head: "Fatura No",
      docType: "HF",
      orderType: "",
      statu: true,
      actions: true,
    },
    {
      slug: "Y1",
      title: "Yansıtma Faturaları",
      head: "Fatura No",
      docType: "Y1",
      orderType: "",
      statu: true,
      actions: true,
    },
    {
      slug: "R1",
      title: "İade Faturaları",
      head: "Fatura No",
      docType: "R1",
      orderType: "",
      statu: true,
      actions: true,
    },
  ]);

  const documentFind = (slug) => {
    documentType.value = documentTypes.value.find((item) => item.slug === slug);
  };

  const documentDownload = async (docnum, doctype) => {
    cardDisabled.value = true;
    await postData({
      method: "getInvContent",
      doctype,
      docnum,
    })
      .then((response) => {
        if (response.error === 1) {
          throw new Error(response.msg);
        }

        var win = window.open(
          "",
          "Title",
          "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=900,height=600,top=" +
            (screen.height /3) +
            ",left=" +
            (screen.width /3)
        );
        win.document.body.innerHTML = response.content;

        win.print();
        // window
        //   .open(URL.createObjectURL(new Blob([response.content], { type: "text/html" })), "_blank")
        //   .print();
      })
      .catch((e) => {
        toast.error("Lütfen tarayıcınızdan Pop-up lar ve yönlendirmeleri etkinleştirin.", {
          position: "bottom-center",
        });
      })
      .finally(() => {
        // API işlemi bittikten sonra
        cardDisabled.value = false;
      });
  };

  // Table
  const tableLoading = ref(true);
  const tableEmptySearch = ref(4);
  const tableSearch_1 = ref("");
  const tableSearch_2 = ref("");
  const tableItems = ref([]);
  const tableColumns = ref([
    {
      text: "Cari Unvan",
      value: "NAME1",
      sortable: false,
    },
    {
      text: "Tarih",
      value: "VALIDFROM",
      sortable: false,
      width: "150px",
    },

    {
      text: "Tutar (TL)",
      value: "GROSS",
      align: "right",
      sortable: false,
      width: "130px",
    },
    {
      text: "KDV (TL)",
      value: "VATAMNT",
      align: "right",
      sortable: false,
      width: "130px",
    },
    {
      text: "Toplam (TL)",
      value: "GRANDTOTAL",
      align: "right",
      sortable: false,
      width: "130px",
    },
  ]);

  const tableColumnDOCNUM = ref({
    text: "Belge No",
    value: "DOCNUM",
    sortable: false,
    width: "100px",
    filter: (f) =>
      tableSearch_2.value === null
        ? ((tableSearch_2.value = ""), f)
        : f.includes(tableSearch_2.value),
  });

  const tableColumnPRINTEDNO = ref({
    text: "Belge No",
    value: "PRINTEDNO",
    sortable: false,
    width: "100px",
    filter: (f) =>
      tableSearch_2.value === null
        ? ((tableSearch_2.value = ""), f)
        : f.includes(tableSearch_2.value),
  });

  const tableColumnSTATX = ref({
    text: "Statü",
    value: "STATX",
    sortable: false,
    width: "150px",
    filter: (f) => `${f}`.toLowerCase().includes(tableSearch_1.value.toLowerCase()),
  });

  const tableColumnACTIONS = ref({
    text: "",
    value: "actions",
    width: "30",
    sortable: false,
  });

  const tableColumnsFn = (folder) => {
    const DOCNUM = tableColumns.value.indexOf(tableColumnDOCNUM.value);

    if (DOCNUM > -1) {
      tableColumns.value.splice(DOCNUM, 1);
    }

    const PRINTEDNO = tableColumns.value.indexOf(tableColumnPRINTEDNO.value);

    if (PRINTEDNO > -1) {
      tableColumns.value.splice(PRINTEDNO, 1);
    }

    const STATX = tableColumns.value.indexOf(tableColumnSTATX.value);

    if (STATX > -1) {
      tableColumns.value.splice(STATX, 1);
    }

    const ACTIONS = tableColumns.value.indexOf(tableColumnACTIONS.value);

    if (ACTIONS > -1) {
      tableColumns.value.splice(ACTIONS, 1);
    }

    if (folder === "order") {
      tableColumns.value.unshift(tableColumnDOCNUM.value);
      tableEmptySearch.value = 5;
    } else {
      tableEmptySearch.value = 6;
      tableColumns.value.unshift(tableColumnSTATX.value, tableColumnPRINTEDNO.value);
      tableColumns.value.push(tableColumnACTIONS.value);
    }
  };

  const tableFetch = async ({ start, end }) => {
    tableItems.value = [];
    isError.value = false;
    tableLoading.value = true;
    cardDisabled.value = true;
    try {
      const data = await postData({
        method: "getCaniasOrders",
        "search[startDate]": start,
        "search[endDate]": end,
        "search[orderType]": documentType.value.orderType,
        "search[docType]": documentType.value.docType,
      });

      tableItems.value = data.detail;
      pageStore.downloadData = tableItems.value;
    } catch (e) {
      // API hataya girdi
      isError.value = true;
      toast.error(`Hata ${e}`);
    } finally {
      cardDisabled.value = false;
      tableLoading.value = false;
    }
  };

  // Table Expand
  const tableExpandEmptySearch = ref(6);
  const tableExpandSearch_1 = ref("");
  const tableExpandSearch_2 = ref("");
  const tableExpandedSync = ref([]);
  const tableExpandLoading = ref(true);
  const tableExpandItems = ref([]);
  const tableExpandColumns = ref([
    {
      text: "Malzeme",
      value: "MATERIAL",
      width: "150",
      sortable: false,
      filter: (f) =>
        tableExpandSearch_1.value === null
          ? ((tableExpandSearch_1.value = ""), f)
          : f.toLowerCase().includes(tableExpandSearch_1.value.toLowerCase()),
    },
    {
      text: "Ürün",
      value: "MTEXT",

      sortable: false,
      filter: (f) =>
        tableExpandSearch_2.value === null
          ? ((tableExpandSearch_2.value = ""), f)
          : f.toLowerCase().includes(tableExpandSearch_2.value.toLowerCase()),
    },
    {
      text: "Miktar",
      value: "QUANTITY",
      width: "90",
      sortable: false,
      align: "right",
    },
    {
      text: "Birim",
      value: "QUNIT",
      width: "90",
      sortable: false,
      align: "left",
    },
    {
      text: "Birim Fiyat",
      value: "SPRICE",
      width: "120",
      sortable: false,
      align: "right",
    },
    {
      text: "Fiyat",
      value: "SUBTOTAL",
      width: "120",
      sortable: false,
      align: "right",
    },
    {
      text: "KDV",
      value: "VATAMNT",
      width: "120",
      sortable: false,
      align: "right",
    },
    {
      text: "Genel Toplam",
      value: "GRANDTOTAL",
      width: "120",
      sortable: false,
      align: "right",
    },
  ]);

  const watchTableExpand = (docnum, doctype) => {
    tableExpandLoading.value = true;
    tableExpandItems.value = [];
    postData({
      method: "getCaniasOrderDetail",
      doctype,
      docnum,
    })
      .then((response) => {
        // API dönüşündeki hatalara bakıyoruz
        if (response.error === 1) {
          throw new Error(response.msg);
        }
        tableExpandItems.value = response.detail;
      })
      .catch((e) => {
        // API hataya girdi
        toast.error(e.message, {
          position: "bottom-center",
        });
      })
      .finally(() => {
        // API işlemi bittikten sonra
        tableExpandLoading.value = false;
      });
  };

  return {
    tableItems,
    tableColumns,
    tableColumnsFn,
    tableLoading,
    tableSearch_1,
    tableSearch_2,
    tableEmptySearch,
    tableFetch,

    tableExpandEmptySearch,
    tableExpandSearch_1,
    tableExpandSearch_2,
    tableExpandedSync,
    tableExpandLoading,
    tableExpandColumns,
    tableExpandItems,
    watchTableExpand,

    documentFind,
    documentType,
    documentDownload,

    cardDisabled,
    isError,
  };
});
